import { render, staticRenderFns } from "./stationeryRecordDetail.vue?vue&type=template&id=2a839412&scoped=true"
import script from "./stationeryRecordDetail.vue?vue&type=script&lang=js"
export * from "./stationeryRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./stationeryRecordDetail.vue?vue&type=style&index=0&id=2a839412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a839412",
  null
  
)

export default component.exports